// extracted by mini-css-extract-plugin
module.exports = {"collapse":"style_collapse__19xxK","panel":"style_panel__1fnbS","panelHeader":"style_panelHeader__3mH3t","videoIcon":"style_videoIcon__2UYlo","teackIcon":"style_teackIcon__2I9d4"};